import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisibilityOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 5L26 27",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3642 19.6998C18.3829 20.5919 17.0874 21.0577 15.7627 20.9946C14.438 20.9316 13.1926 20.3449 12.3005 19.3636C11.4084 18.3823 10.9426 17.0868 11.0057 15.762C11.0687 14.4373 11.6554 13.1919 12.6367 12.2998",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9414 11.0889C18.0044 11.2924 18.9727 11.8354 19.7007 12.6363C20.4287 13.4371 20.8773 14.4526 20.9789 15.5301",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.0763 21.1375C28.8013 18.6975 30 16 30 16C30 16 26 7.00001 16 7.00001C15.1341 6.99883 14.2695 7.06907 13.415 7.21001",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.25 8.5752C4.15375 11.1552 2 16.0002 2 16.0002C2 16.0002 6 25.0002 16 25.0002C18.3431 25.0186 20.657 24.4787 22.75 23.4252",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgVisibilityOff;
